import { isValidDate } from "util/DateTime";
const transformKey = (key, indices, formatTimestamp) => {
  if (indices.length === 0) {
    return key;
  }
  const newKey = key.slice();
  indices.forEach((idx) => {
    if (newKey[idx]) {
      const value = newKey[idx];
      newKey[idx] = isValidDate(value) ? formatTimestamp(newKey[idx], "internal") : value;
    }
  });
  return newKey;
};
const findIndices = (ary, predicate) => ary.map((value, idx) => ({ value, idx })).filter(({ value }) => predicate(value)).map(({ idx }) => idx);
export default (rowPivots, columnPivots, formatTime) => (result = []) => {
  const rowIndices = findIndices(rowPivots, (pivot) => pivot.type === "time");
  const columnIndices = findIndices(columnPivots, (pivot) => pivot.type === "time");
  if (rowIndices.length === 0 && columnIndices.length === 0) {
    return result;
  }
  return result.map((row) => {
    if (row.source !== "leaf") {
      return row;
    }
    const newRow = { ...row };
    newRow.key = transformKey(row.key, rowIndices, formatTime);
    if (columnIndices.length > 0) {
      newRow.values = row.values.map((values) => {
        if (values.source !== "col-leaf") {
          return values;
        }
        const newValues = { ...values };
        newValues.key = transformKey(values.key, columnIndices, formatTime);
        return newValues;
      });
    }
    return newRow;
  });
};
